import { render, staticRenderFns } from "./404.vue?vue&type=template&id=c0b5dde4&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=c0b5dde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b5dde4",
  null
  
)

export default component.exports